export default __webpack_public_path__ + "static/media/planet-3.ed08a7ab.svg";